import { render, staticRenderFns } from "./waybillInformation.vue?vue&type=template&id=44f55e9a&scoped=true"
import script from "./waybillInformation.vue?vue&type=script&lang=js"
export * from "./waybillInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f55e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f55e9a')) {
      api.createRecord('44f55e9a', component.options)
    } else {
      api.reload('44f55e9a', component.options)
    }
    module.hot.accept("./waybillInformation.vue?vue&type=template&id=44f55e9a&scoped=true", function () {
      api.rerender('44f55e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/waybillInformation/waybillInformation.vue"
export default component.exports